import { intComma } from 'humanize-plus'
import { map } from 'ramda'
import React,
{
  Component,
  Fragment
} from 'react'
import { connect } from 'react-redux'

import { generateContactsWebAppConfig } from '@driftt/app-config'
import {
  Button,
  Div,
  Input,
  Span,
  ToolTip
} from '@driftt/tide-core'
import {
  access,
  integrationStatus,
  showTransientNotification
} from '@driftt/traffic-control'
import { getContactToEnroll } from 'api/contacts'
import {
  addToMemberList,
  createStaticSegment
} from 'api/segments'
import Config from 'config'
import { generateQueryString } from 'utils'

import StaticSegmentModal from './StaticSegmentModal'

import './style.css'

const mapStateToProps = state => ({
  selectedContacts: state.__CRM.contacts.selectedContacts,
  appConfig: generateContactsWebAppConfig(state.user),
})

const mapDispatchToProps = dispatch => {
  return {
    onSuccess: () => dispatch(showTransientNotification({
      type: 'success',
      message: 'Your selected users have been added to the segment'
    }))
  }
}

class ContactListControls extends Component {
  constructor(props) {
    super(props)

    this.state = {
      staticSegmentModalOpen: false,
      showSequenceEnroll: false,
      emailArray: null,
      isOutreachConnected: integrationStatus.isIntegrationConnected('outreach')
    }
  }

  messageEventHandler = (event) => {
    const frame = document.getElementById("segment-sequence-enroll-frame")

    if (event.source !== frame && !event.data.type) {
      return
    }
    if (event.data.type ==='@@driftext/hide_enroll_modal' ) {
      this.setState({ showSequenceEnroll: false })
    }
  }

  componentDidMount() {
    window.addEventListener('message', this.messageEventHandler, false)
  }

  componendWillUnmount() {
    window.removeEventListener('message', this.messageEventHandler, false)
  }

  saveAsNewStaticSegment = async (name) => {
    const { selectedContacts } = this.props

    const staticSegment = {
      type: 'ID_LIST',
      name
    }

    try {
      const { data } = await createStaticSegment(staticSegment)

      await addToMemberList(selectedContacts, data.id)

    } catch(e) {
      console.warn(e)
    }
  }

  addToExistingSegment = async (id) => {
    const { selectedContacts } = this.props

    try {
      await addToMemberList(selectedContacts, id)

    } catch(e) {
      console.warn(e)
    }
  }

  enrollInSequence = async () => {
    const { selectedContacts } = this.props

    try {
      const { data } = await getContactToEnroll(selectedContacts)

      const grabEmail = (contact) => {
        const { email } = contact
        return encodeURIComponent(email)
      }

      const emails = map(grabEmail, data)

      const generatedQueryString = generateQueryString(emails, 'email').join('')

      this.setState({
        showSequenceEnroll: true,
        emailArray: generatedQueryString + "&source=CRM"
      })
    } catch(e) {
      console.warn(e)
    }
  }

  toggleStaticModal = () => {
    this.setState(prevState => ({ staticSegmentModalOpen: !prevState.staticSegmentModalOpen }))
  }

  toggleSequenceEnrollModal = () => {
    this.setState(prevState => ({ showSequenceEnroll: !prevState.showSequenceEnroll }))
  }

  renderSelectedToolbar = () => {
    const {
      selectedContacts,
      selectAll,
      deleteContacts,
      appConfig: { hasEnrollInSequence }
    } = this.props
    const { isOutreachConnected } = this.state
    const isActiveSalesSequenceOrg = access.hasGates('is_active_sales_sequence_org')

    const shouldShowEnrollInSequenceButton = hasEnrollInSequence && (isOutreachConnected || isActiveSalesSequenceOrg)

    const disableEnrollButton = isOutreachConnected && (selectedContacts.length > 1)

    return (
      <Fragment>
        <Div className="contacts-text-controls">
          <Span>{`${intComma(selectedContacts.length)} contacts selected`}</Span>
          <Span className="link" onClick={() => selectAll(true)}>Select page</Span>
          <Span className="link" onClick={() => selectAll(false)}>Clear</Span>
        </Div>
        <Div className="contact-controls-button-group">
          <Button type="utility" icon="donut-chart-2"
            onClick={this.toggleStaticModal}>
            Save static segment
          </Button>
          {shouldShowEnrollInSequenceButton && (
            <ToolTip
              component={<Div> Enrolling multiple people in a <br/> sequence at one time is not <br/> available with the Outreach <br/> integration.</Div>}
              hover={disableEnrollButton}
              flow='up'
            >
              <Button disabled={disableEnrollButton} icon="inbox-full"
                type="utility" onClick={this.enrollInSequence}>
              Enroll in sequence
              </Button>
            </ToolTip>
          )}
          <Button icon="trash" type="utility"
            onClick={() => deleteContacts()}>
            Delete contacts
          </Button>
        </Div>
      </Fragment>
    )
  }
  render() {
    const {
      onChange,
      showSegmentation,
      selectedContacts,
      contacts
    } = this.props
    const {
      staticSegmentModalOpen,
      showSequenceEnroll,
      emailArray
    } = this.state

    return (
      <Div className="contacts-controls">
        <Div className="contact-controls-text-actions">
          {(selectedContacts.length === 0) &&
            <Div>
              {`${intComma(contacts)} contacts`}
            </Div>
          }
          {(selectedContacts.length > 0) &&
            this.renderSelectedToolbar()
          }
        </Div>
        <Div className="contact-controls-right">
          <Button type="tertiary" icon={'pb-filter'}
            onClick={() => showSegmentation()}>Create filter
          </Button>
          <Input className="input-search" type="search"
            onChange={(event) => onChange(event)} placeholder="Search your contacts"/>
        </Div>
        {!!staticSegmentModalOpen &&
          <StaticSegmentModal
            open={staticSegmentModalOpen}
            onClose={this.toggleStaticModal}
            saveAsNew={this.saveAsNewStaticSegment}
            addToExisting={this.addToExistingSegment}
            numberOfSelectedContacts={selectedContacts.length}
          />
        }
        {showSequenceEnroll &&
          <Div className="contact-sequence-enroll-wrapper">
            <Div className="contact-sequence-enroll">
              <iframe id="contact-sequence-enroll-frame" title="Enroll your sequence"
                src={`${Config.SEQUENCE_ENROLL}${emailArray}`} />
            </Div>
          </Div>
        }
      </Div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactListControls)
